
export const actionCodeSettings = {
    // URL you want to redirect back to. The domain (www.example.com) for this
    // URL must be in the authorized domains list in the Firebase Console.
    url: `https://${process.env.REACT_APP_DOMAIN}/auth-link`,
    // This must be true.
    handleCodeInApp: true,
};
